<template>
  <div class="rt60">
    <!-- <top-nav></top-nav> -->
    <banner :child-data="fdata"></banner>
    <div id="solution-main" class="container " data-ani="">
      <div class="solution-info">
        <div class="info-title">
          <span class="line"></span>
          <span class="title-text">{{$t('SolutionTip')}}</span>
          <span class="line"></span>
        </div>
        <div class="info-main">
          <div class="main-content">
            <div class="row">
              <div class="col-sm-4 col-md-4 text-center">
                <img src="img/portfolio/Aisoc.png" alt />
                <h3>{{$t('SolutionTH0')}}</h3>
                <p>{{$t('SolutionTP0')}}</p>
              </div>
              <div class="col-sm-4 col-md-4 text-center">
                <img src="img/portfolio/pingtai.png" alt />
                <h3>{{$t('SolutionTH1')}}</h3>
                <p>{{$t('SolutionTP1')}}</p>
              </div>
              <div class="col-sm-4 col-md-4 text-center">
                <img src="img/portfolio/yunduan.png" alt />
                <h3>{{$t('SolutionTH2')}}</h3>
                <p>{{$t('SolutionTP2')}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4 col-md-4 text-center">
                <img src="img/portfolio/ai.png" alt />
                <h3>{{$t('SolutionTH3')}}</h3>
                <p>
                  {{$t('SolutionTP3')}}
                </p>
              </div>
              <div class="col-sm-4 col-md-4 text-center">
                <img src="img/portfolio/code.png" alt />
                <h3>{{$t('SolutionTH4')}}</h3>
                <p>{{$t('SolutionTP4')}}</p>
              </div>
              <div class="col-sm-4 col-md-4 text-center">
                <img src="img/portfolio/shengtai.png" alt />
                <h3>{{$t('SolutionTH5')}}</h3>
                <p>
                  {{$t('SolutionTP5')}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section row rcen  " data-ani="">
        <h3>Solution - New</h3>
        <img src="img/portfolio/newSolution_cn.png" alt />
      </div>

      <div class="section row rcen  " data-ani="">
        <h3>Solution - Update</h3>
        <img src="img/portfolio/oldUpgrade_cn.png" alt />
      </div>

      <div class="info-main mb80  " data-ani="">
        <div class="main-content">
          <div class="row">
            <div class="row" style="width:100%">
              <div class="col-sm-6 col-md-6">
                <div class="thumbnail">
                  <img src="img/portfolio/solution_adv1.png" alt="..." />
                  <div class="caption">
                    <h3>{{$t('SolutionTH6')}}</h3>
                    <p>{{$t('SolutionTP6')}}</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6">
                <div class="thumbnail">
                  <img src="img/portfolio/solution_adv2.png" alt="..." />
                  <div class="caption">
                    <h3>{{$t('SolutionTH7')}}</h3>
                    <p>{{$t('SolutionTP7')}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="company-develop  " data-ani="">
        <div class="section row light">
          <div class="sec_left col-xs-12 col-md-12">
            <div class="info-title">
              <span class="line"></span>
              <span class="title-text">{{$t('SolutionCS')}}</span>
              <span class="line"></span>
            </div>

            <b-card no-body>
              <b-tabs content-class="mt-3" fill>
                <b-tab :title="$t('SolutionCS0')" active>
                  <!-- <p>I'm the first tab</p> -->
                  <div
                    class="tab-pane active sec_le_text"
                    :id="$t('SolutionCS0')"
                    style="display:flex"
                  >
                    <div class="col-md-6 textLe">
                      <h3>{{$t('SolutionCP0')}}</h3>

                      <h3>{{$t('SolutionCP1')}}</h3>

                      <h3>{{$t('SolutionCP2')}}</h3>

                      <h3>{{$t('SolutionCP3')}}</h3>
                    </div>

                    <div class="d-block d-sm-none">
                      <img class="pw100" src="img/portfolio/shebei.png" alt />
                    </div>
                    <div class="sec_right col-md-2 col-md-offset-1 d-none d-sm-block mt20">
                      <img class="pw100" src="img/portfolio/shebei.png" alt />
                    </div>
                  </div>
                </b-tab>
                <b-tab :title="$t('SolutionCS1')">
                  <!-- <p>I'm the second tab</p> -->
                  <div class="tab-pane sec_le_text" :id="$t('SolutionCS1')" style="display:flex">
                    <div class="col-md-6 textLe">
                      <h3>{{$t('SolutionCP10')}}</h3>

                      <h3>{{$t('SolutionCP11')}}</h3>

                      <h3>{{$t('SolutionCP12')}}</h3>

                      <h3>{{$t('SolutionCP13')}}</h3>
                    </div>
                    <div class="d-block d-sm-none">
                      <img class="pw100" src="img/portfolio/danao.png" alt />
                    </div>
                    <div class="sec_right col-md-2 col-md-offset-1 d-none d-sm-block mt20">
                      <img class="pw100" src="img/portfolio/danao.png" alt />
                    </div>
                  </div>
                </b-tab>
                <b-tab :title="$t('SolutionCS2')">
                  <!-- <p>I'm the tab with the very, very long title</p> -->
                  <div class="tab-pane sec_le_text" :id="$t('SolutionCS2')" style="display:flex">
                    <div class="col-md-6 textLe">
                      <h3>{{$t('SolutionCP20')}}</h3>

                      <h3>{{$t('SolutionCP21')}}</h3>

                      <h3>{{$t('SolutionCP22')}}</h3>

                      <h3>{{$t('SolutionCP23')}}</h3>
                    </div>
                    <div class="d-block d-sm-none">
                      <img class="pw100" src="img/portfolio/shipin.png" alt />
                    </div>
                    <div class="sec_right col-md-2 col-md-offset-1 d-none d-sm-block mt20">
                      <img class="pw100" src="img/portfolio/shipin.png" alt />
                    </div>
                  </div>
                </b-tab>
                <b-tab :title="$t('SolutionCS3')">
                  <!-- <p>I'm a disabled tab!</p> -->
                  <div class="tab-pane sec_le_text" :id="$t('SolutionCS3')" style="display:flex">
                    <div class="col-md-6 textLe">
                      <h3>{{$t('SolutionCP30')}}</h3>

                      <h3>{{$t('SolutionCP31')}}</h3>

                      <h3>{{$t('SolutionCP32')}}</h3>

                      <h3>{{$t('SolutionCP33')}}</h3>
                    </div>
                    <div class="d-block d-sm-none">
                      <img class="pw100" src="img/portfolio/diannao.png" alt />
                    </div>
                    <div class="sec_right col-md-2 col-md-offset-1 d-none d-sm-block mt20">
                      <img class="pw100" src="img/portfolio/diannao.png" alt />
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </div>
        <!-- <div class="section row">
        <div class="sec_right col-md-4 col-md-offset-2 hidden-xs">
          <img class="pw100" src="img/portfolio/group_17.png" alt="">
        </div>
        <div class="sec_left col-xs-12 col-md-8 pr20 col-md-offset-1">
          <div class="sec_le_title">
            Device management
          </div>
          <div class="sec_le_text">
            服务于设备授权和影像优化等个人设备IoT场景，以个人设备等终端硬件为承载，为提升个人生活的安全性和数字化体验提供软硬一体化解决方案。
          </div>
          <div class="sec_example">
            <a href="./portfolio_detail.html?cate=mobile">Monitor the device status</a>
            <a href="./portfolio_detail.html?cate=mobile">Restart, shutdown device</a>
            <a href="./portfolio_detail.html?cate=mobile">OTA upgrade</a>
            <a href="./portfolio_detail.html?cate=mobile">Log analysis</a>
          </div>
        </div>
        <div class="visible-xs">
          <img class="pw100" src="img/portfolio/group_17.png" alt="">
        </div>
        </div>-->
      </div>
    </div>
    <!-- <footer-bot></footer-bot> -->
  </div>
</template>

<script>
import "../../public/css/font-awesome.min.css";
import $ from "../../public/js/jquery.min.js";
import topNav from "../components/top";
import banner from "../components/banner";
import footerBot from "../components/footerBot";
import { mapMutations } from "vuex";

export default {
  name: "solution",
  components: {
    topNav,
    banner,
    footerBot
  },
  data() {
    return {
      fdata: {
        h1: "Solution",
        h2: "AI Turnkey Solution of Device-to-Cloud",
        style: {
          background:
            "url(../img/portfolio/jjfa_banner@3x.jpg)  center top 100% no-repeat ",
          backgroundSize: "100% 100%"
        }
      }
    };
  },
  methods: {
    ...mapMutations(["editMenu"])
  },
  mounted() {
    this.editMenu("solution");
  }
};
</script>

<style scoped>
.main-content .col-md-4 {
  padding-bottom: 0px;
}

.thumbnail {
  border: none;
  text-align: center;
  margin-bottom: 0px;
}

.thumbnail h3 {
  margin-bottom: 20px;
}

.thumbnail p {
  margin-bottom: 10px;
}

.thumbnail > img,
.thumbnail a > img {
  width: 18%;
}

#solution-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}

.main-content {
  width: 100%;
}

.main-content .row {
  margin-right: -15px;
}

#solution-main .solution-info {
  padding: 80px 0px;
  box-sizing: border-box;
}
#solution-main .solution-info .main-content img {
  width: 60%;
}
#solution-main .info-title,
#solution-main .develop-title {
  margin-bottom: 40px;
  background: orange;
  border-radius: 24px;
  padding: 10px 30px;
  color: white;
  text-align: left;
}

#solution-main .info-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin-bottom: 80px; */
}
#solution-main .info-main.mb80 {
  margin-bottom: 80px;
}

#solution-main .info-title .title-text,
#solution-main .develop-title .title-text {
  font-size: 30px;
}

.tab-content {
  background-color: #fff;
  border: 1px solid #ddd;
  border-top: 0;
  padding: 15px 15px 5px;
  box-sizing: border-box;
}

.progress {
  box-shadow: none;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.06);
}

.progress .progress-bar {
  box-shadow: none;
  background-color: #32b9b1;
}

.progress .progress-bar-success {
  background-color: #51be38;
}

.progress .progress-bar-info {
  background-color: #5bc0de;
}

.progress .progress-bar-warning {
  background-color: #ef9544;
}

.progress .progress-bar-danger {
  background-color: #f05a5b;
}

.well {
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0.05);
}

.timeline {
  list-style: none;
  position: relative;
  max-width: 1200px;
  padding: 20px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
}

.timeline:after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -2px;
  background-color: rgba(0, 0, 0, 0.2);
  height: 100%;
  width: 4px;
  border-radius: 2px;
  display: block;
}

.timeline .timeline-row {
  padding-left: 50%;
  position: relative;
  z-index: 10;
  box-sizing: border-box;
}

.timeline .timeline-row .timeline-time {
  position: absolute;
  right: 50%;
  top: 31px;
  text-align: right;
  margin-right: 40px;
  font-size: 16px;
  line-height: 1.3;
  font-weight: 600;
}

.timeline .timeline-row .timeline-time small {
  display: block;
  color: #fff;
  text-transform: uppercase;
  opacity: 0.75;
  font-size: 11px;
  font-weight: 400;
}

.pw100 {
  width: 100%;
}

.section.row {
  display: flex;
  align-items: flex-start;
  overflow: hidden;
  margin-bottom: 80px;
}

.pr20 {
  padding-right: 20%;
}

.pl20 {
  padding-left: 20%;
}

.sec_le_title {
  margin-bottom: 40px;
  background: orange;
  border-radius: 24px;
  padding: 10px 30px;
  color: white;
  text-align: left;
  color: white;
  /* font-weight: 400; */
}

.tab-content {
  border: none;
}

.myTabContent h3 {
  font-size: 16px;
}

.myTabContent p {
  font-size: 14px;
  margin-bottom: 0px;
}

.sec_example {
  margin-top: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.sec_example a {
  margin-right: 20px;
}

#myTabContent1 > div h3,
#myTabContent1 > div p {
  float: left;
  text-align: left;
}

#myTabContent1 > div h3:nth-child(odd) {
  width: 35%;
}

#myTabContent1 > div h3:nth-child(even) {
  width: 65%;
}

#myTabContent1 > div p {
  width: 60%;
}

.section.row.rcen {
  display: flex;
  align-items: center;
  overflow: hidden;
  margin-bottom: 80px;
  justify-content: center;
  flex-direction: column;
  border: 2px solid skyblue;
  border-radius: 20px;
  padding: 50px 30px;
  overflow: unset;
  position: relative;
}

.section.row.rcen h3 {
  position: absolute;
  top: -41px;
  width: 18%;
  left: 32px;
  text-align: center;
  color: skyblue;
  background: white;
  border: 2px solid skyblue;
  border-radius: 14px;
  padding: 4px;
  background-color: white;
}
.sec_le_text {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.textLe {
  text-align: left;
}
.textLe h3 {
  font-weight: 400;
  font-size: 16px;
}
.section.row.rcen img {
  width: 100%;
}

@media screen and (max-width: 480px) {
  .company-develop .nav > li > a {
    padding: 10px 5px;
  }
}

/* @media(max-width:768px) {
    div {
        font-size: 14px;
    }
    .pr20 {
        padding-right: 0;
    }
    .pl20 {
        padding-left: 15px;
        padding-right: 0;
    }
    .sec_le_title {
        text-align: center;
        margin-bottom: 0;
        padding-top: 10px;
        font-size: 20px;
    }
    .sec_le_text {
        padding: 15px;
    }
    #solution-main .company-info {
        padding: 80px 0px;;
    }
    #solution-main .info-title {
        margin-bottom: 15px;
    }
    .main-content {
        width: 100%;
        padding: 0 15px;
    }
    #solution-main .info-title .title-text {
        color: #333;
        font-weight: 400;
        font-size: 20px
    }
} */
@media screen and (max-width: 480px) {
  #solution-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/portfolio/jjfa_banner@3x.jpg) no-repeat
      center;
    background-size: 100% 100%;
  }

  #solution-main .solution-info {
    padding: 40px 0;
  }

  .pl20 {
    padding: 20px;
    text-align: center;
  }

  .section.row {
    text-align: center;
  }

  .pr20 {
    padding: 20px;
  }

  .section.row {
    flex-direction: column;
  }

  .pw100 {
    width: 66%;
  }
}
.card {
  border: 0 !important;
}
.rt60 {
  position: relative;
  top: -60px;
    margin-bottom: -60px;
}
</style>